<template>
  <div class="col-12">
    <div class="row align-items-center mt-3">
      <div class="col-12 col-lg-6 ">
        <p class="font-bold">Befindet sich Ihr Objekt in einem besonderen Gebäude?</p>
      </div>
      <div class="col-12 col-lg-6">
          <Field as="select" v-model="surveyStore.data.besonderes_gebaeude" id="besonderes_gebaeude" name="besonderes_gebaeude" class="form-select" :class="{'is-invalid': errors.besonderes_gebaeude}">
            <option value="">--- Bitte auswählen ---</option>
            <template v-for="option in surveyStore.currentConfig.currentStep.besonderes_gebaeude.selectOptions" :key="option.key">
              <option :value="option.key">{{ option.label }}</option>
            </template>
          </Field>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field} from 'vee-validate';
export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {
    }
  },
  props: {
    errors: Object,
  },
  methods: {
  },

}
</script>
